import React, { useState, useRef } from "react";
import { Form, Button, InputGroup, Row, Col } from "react-bootstrap";

function AddItem({ addItem }) {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [showForm, setShowForm] = useState(false); // Nouvel état pour afficher/masquer le formulaire

  const nameInputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !price || !quantity) return;
    addItem(name, price, quantity);
    setName("");
    setPrice("");
    setQuantity("");
    nameInputRef.current && nameInputRef.current.focus();
    // Ne plus masquer le formulaire ici
  };

  const handleOpenForm = () => {
    setShowForm(true);
    setTimeout(() => {
      nameInputRef.current && nameInputRef.current.focus();
    }, 100);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setName("");
    setPrice("");
    setQuantity("");
  };

  if (!showForm) {
    return (
      <Button
        variant='primary'
        className='mb-3 w-100 btn-sm'
        onClick={handleOpenForm}>
        Ajouter un article
      </Button>
    );
  }

  return (
    <Form onSubmit={handleSubmit} className='mb-5'>
      <InputGroup className='mt-3 mb-3'>
        <Form.Label htmlFor='item-name' visuallyHidden>
          Nom de l'article
        </Form.Label>
        <Form.Control
          id='item-name'
          className='border-info'
          ref={nameInputRef}
          placeholder="Nom de l'article"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoComplete='off'
        />
      </InputGroup>
      <InputGroup className='mb-3'>
        <Form.Label htmlFor='item-price' visuallyHidden>
          Prix
        </Form.Label>
        <Form.Control
          id='item-price'
          className='border-info'
          type='number'
          placeholder='Prix'
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          min='0'
          step='0.01'
        />
      </InputGroup>
      <InputGroup className='mb-3'>
        <Form.Label htmlFor='item-quantity' visuallyHidden>
          Quantité
        </Form.Label>
        <Form.Control
          id='item-quantity'
          className='border-info'
          type='number'
          placeholder='Quantité'
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          min='1'
          step='1'
        />
      </InputGroup>
      <Row>
        <Col>
          <Button variant='primary' type='submit' className='w-100 btn-sm'>
            Ajouter
          </Button>
        </Col>
        <Col>
          <Button
            variant='danger'
            type='button'
            className='w-100 btn-sm'
            onClick={handleCloseForm}>
            Fermer
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default AddItem;
